// @flow
import {type SagaIterator} from 'redux-saga';
import {sendEvent} from '@optimaxdev/analytics/mobile';

import type {ActionType} from 'constants/flow/flowTypes';
import {CATEGORY} from 'constants/actions';

import {takeEvery, call} from 'redux-saga/effects';
import type {FilterActionType} from 'reducers/category/filters/filtersType';

/**
 * Send event that a user has changed a sort value
 * @param {{sortBy: string, sortOrder: string}} - Sort data
 */
export function* sortItems({sortOrder, sortBy}: {sortBy: string, sortOrder: string}): SagaIterator {
    yield call(sendEvent, 'event', {
        name: 'Sort Items',
        properties: {
            dyType: 'sort-items-v1',
            sortOrder: sortOrder.toUpperCase(),
            sortBy,
        },
    });
}

/**
 * On sort items changed send dynamic yield analytics
 * @param {{sort: {option: string, name: string}}} - Sort data
 */
export function* onSortChanged({sort}: {sort: {option: string, name: string}}): SagaIterator {
    yield call(sortItems, {
        sortBy: sort.option,
        sortOrder: sort.name,
    });
}

/**
 * Send event that a user has changed a filter value
 * @param {ActionType<FilterActionType>} action - Action
 */
export function* filterItems(action: ActionType<FilterActionType>): SagaIterator {
    const {codeFilter, value} = action.payload;
    yield call(sendEvent, 'event', {
        name: 'Filter Items',
        properties: {
            dyType: 'filter-items-v1',
            filterType: codeFilter,
            filterStringValue: value,
        },
    });
}

/**
 * Support saga function for category
 */
export default function* dynamicYieldSagaCategory(): SagaIterator {
    yield takeEvery(CATEGORY.CHANGED_FILTER, filterItems);
    yield takeEvery(CATEGORY.GET_ACTIVE_SORT, onSortChanged);
}
